// extracted by mini-css-extract-plugin
export var copyableField = "_ry-4";
export var customerBadge = "_ry-0";
export var customerInfoTitle = "_ry-2";
export var details = "_ry-1";
export var dropdownContainer = "_ry-5";
export var dropdownImage = "_ry-6";
export var editAssigneeForm = "_ry-a";
export var editButton = "_ry-3";
export var email = "_ry-7";
export var hidden = "_ry-d";
export var input = "_ry-8";
export var saveButton = "_ry-b";
export var shopifyIcon = "_ry-c";
export var suggestionBadge = "_ry-e";
export var suggestionText = "_ry-f";
export var username = "_ry-9";